import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pwnage?",
  "description": "",
  "published": "2007-05-08T00:00:00.000Z",
  "redirect_from": ["/blog/pwnage/swizec/219"],
  "categories": "linkages",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I watched the new episode of `}<a parentName="p" {...{
        "href": "http://www.purepwnage.com"
      }}>{`Pure Pwnage`}</a>{`. It was the first in the second season of the show and I would have completely missed knowing of its existance if it weren't for a friendly advertising bulleting on myspace from The Pwnerer himself. Yes, I am in fact such a nerd that I added him as a friend, go figure. Stroke of marketing genious these `}<em parentName="p">{`friendly`}</em>{` bulletins.`}</p>
    <p>{`Anyhow, the episode was quite enjoyable and I have to say I missed the show. It feels much better now, they seem to have gotten some new equipment so the quality is better and Kyle seems to have learned stuff in school because even that part feels better. Or I've just been away from it for too long.`}</p>
    <p>{`Now what is really condemnable and not very nice of them is that the new episodes cannot be downloaded. They can only be watched as streams in a flash based player which brings a number of bad consequences. One is that the screen saver doesn't automatically turn off as it does when a real player is running. Another is the immense usage of RAM and CPU that simply isn't there with a real player. Don't get me wrong, there's nothing `}<em parentName="p">{`profoundly`}</em>{` wrong with that, it's just rather annoying that you have to devote your whole computer to watching a sitcom.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      